import { createSlice } from '@reduxjs/toolkit';

export interface TwoFADeActivateModalSliceState {
  isOpen: boolean;
}

const initialState: TwoFADeActivateModalSliceState = {
  isOpen: false,
};

const twoFADeActivateModalSlice = createSlice({
  name: 'twoFADeActivateModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export { twoFADeActivateModalSlice };
